/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Settings } from '../../assets/themes/OPL/img/icons/Settings.svg';

function SettingsButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Settings}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

SettingsButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
    tooltipTitle: PropTypes.string,
};

export default SettingsButton;
